// pseudo implementation / workaround of canceling fetch

// port of https://github.com/zazukoians/cancelable-fetch/blob/master/index.js

interface CancelableFetch {
  // tslint:disable-next-line:no-any
  promise: Promise<Response>;
  cancel: () => void;
}

export function cancelableFetch(fetch: Promise<Response>): CancelableFetch {
  let abort = false;

  const promise = new Promise<Response>((resolve, reject) => {
    fetch.then((response) => {
      if (abort) {
        if (response.body && response.body.getReader) {
          response.body.getReader().cancel();
        }
        reject(new Error('Fetch canceled manually'));
      } else {
        resolve(response);
      }
    });
  });

  const cancel = () => {
    abort = true;
  };

  return { promise, cancel };
}
